import { JSX } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { MODULE_VERSION_TEST_CASES_COLUMN_ID } from "../constants";
import { ModuleVersionTestCaseRow } from "../types";
import ModuleVersionTestCasesTableCommitCell from "./CommitCell";
import ModuleVersionTestCasesTableDropdownCell from "./DropdownCell";
import ModuleVersionTestCasesTableNameCell from "./NameCell";
import ModuleVersionTestCasesTableStartedAtCell from "./StartedAtCell";
import ModuleVersionTestCasesTableStatusCell from "./StatusCell";

export const MODULE_VERSION_TEST_CASES_TABLE_CELLS: Record<
  MODULE_VERSION_TEST_CASES_COLUMN_ID,
  (props: TableSimpleCellProps<ModuleVersionTestCaseRow>) => JSX.Element
> = {
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.STATUS]: ModuleVersionTestCasesTableStatusCell,
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.NAME]: ModuleVersionTestCasesTableNameCell,
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.COMMIT]: ModuleVersionTestCasesTableCommitCell,
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.STARTED_AT]: ModuleVersionTestCasesTableStartedAtCell,
  [MODULE_VERSION_TEST_CASES_COLUMN_ID.DROPDOWN]: ModuleVersionTestCasesTableDropdownCell,
};
